/* eslint-disable no-undef */
import markerImage from '../../images/new-marker.svg';
import uploadErrorImage from '../../images/upload_error.svg';

$(function() {
    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
    };
});

export const progressBar = {
    init: function ($formId, stepsCount, stepCurrent) {
        let $pieProgress = $formId.find('.pieProgress');
        $pieProgress.asPieProgress({
            namespace: 'pieProgress',
            size: 70,
            barcolor: '#E85270',
            trackcolor: '#F0F6FF',
            barsize: 3,
        });
        this.next($formId, stepsCount, stepCurrent);
    },
    next: function ($formId, stepsCount, stepCurrent) {
        let $pieProgress = $formId.find('.pieProgress');
        let $progressParent = $formId.find('#progressForm');
        let percent = Math.round((stepCurrent / stepsCount) * 100);
        percent = (stepsCount === 0 && stepCurrent === 0) ? 0 : percent;
        $pieProgress.asPieProgress('go', percent);
        $pieProgress.children('.progress__meter').children('.progress__label').text('STEP ' + (stepCurrent + 1));
        $progressParent.children('.progress-bar__position').css('width', percent + '%');
        $progressParent.children('.progress-bar__position').children('.progress-bar__position--tooltip').find('span').text(percent);
    }
}

export let coordinate = [];
export const postCode = {
    $formElement: '',
    postCodeCount: $('#postCode').children('.item-pc').length,
    maxSelectPostcode: 3,
    centerInit: { lat: 51.509865, lng: -0.118092 },
    addDisabledButton: function ($stepperForm, status) {
        if(status) {
            $($stepperForm).find('#addPostCode').removeClass('disabled');
            $($stepperForm).find('#addPostCode').attr('disabled', false);
        } else {
            $($stepperForm).find('#addPostCode').addClass('disabled');
            $($stepperForm).find('#addPostCode').attr('disabled', true);
        }
    },
    addItem: function ($stepperForm) {
        let postcode = $stepperForm.find('input[name="postcode"]').val();
        let radius = $stepperForm.find('select[name="radius"] :selected').val();
        if(this.postCodeCount < this.maxSelectPostcode) {
            this.postCodeCount = this.postCodeCount + 1;
            this.addMapMarker(postcode, radius);
            this.addDisabledButton($stepperForm, false);
            $stepperForm.find('input[name="postcode"]').val('');
            $stepperForm.find('select[name="radius"]').val('');
            $stepperForm.find('select[name="radius"] option').prop('selected', false);
            $stepperForm.find('select[name="radius"]').val(null).trigger("change");
        }
        if(this.postCodeCount === this.maxSelectPostcode) {
            this.addDisabledButton($stepperForm, false);
        }
    },
    removeItem: function ($this) {
        this.postCodeCount = this.postCodeCount - 1;
        let lat = parseFloat($this.parent('.input-post-code').children('.input-lat').val());
        let lng = parseFloat($this.parent('.input-post-code').children('.input-lng').val());
        let radius = parseFloat($this.parent('.input-post-code').children('.input-radius').val());
        postCode.removeMapMarker(lat, lng, radius);
        $this.parent('.input-post-code').parent().remove();
        if(this.postCodeCount < this.maxSelectPostcode) {
            this.addDisabledButton(this.$formElement, true);
        }
    },
    addMapMarker: function (postcode, radius) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': postcode }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                let latitude = results[0].geometry.location.lat();
                let longitude = results[0].geometry.location.lng();
                if(!isInArray(latitude, longitude, coordinate) && coordinate.length < 3) {
                    coordinate.push({lat: latitude, lng: longitude, radius: radius });
                    $('#postCode').append(postcodeItem(postcode, latitude, longitude, radius));
                    mapMarker.showMarker(postCode.centerInit, coordinate);
                } else {
                    postCode.postCodeCount = parseInt($('#postCode').children('.item-pc').length);
                }
            } else {
                postCode.postCodeCount = parseInt($('#postCode').children('.item-pc').length);
                alert('Wrong post code! Please enter correct post code');
            }
        });
    },
    removeMapMarker: function (lat, lng, radius) {
        coordinate = coordinate.filter((item) => item.lat !== lat && item.lng !== lng && item.radius !== radius);
        mapMarker.showMarker(this.centerInit, coordinate);
    },
    showMap: function () {
        mapMarker.showMarker(this.centerInit, coordinate);
    },
};

export const imageField = {
    triggerFile: function($formElement) {
        $formElement.find('.form-group').children('.company_logo_input').trigger('click');
    },
    removeFile: function ($this) {
        $('#company-logo-output').attr('src', "");
        $('.preview-company-logo').addClass('d-none');
        $('#company_logo_croped').val('');
        $('.company_logo_input').val('');
        $('.upload-company-link').removeClass('d-none');
        $('.preview-company-logo').removeClass('upload-error');
        $this.closest('.form-group').find('.upload-error-text').remove();
    },
};

export const marketingPhotoField = {
    triggerFile: function($formElement) {
        $formElement.find('.form-group').children('#step_2marketing_photos').trigger('click');
    }
};

export const mapMarker = {
    showMarker: function (centerInit, coordinate) {
        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: 9,
            center: centerInit,
            disableDefaultUI: true,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dae9f5"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "gamma": 0.01
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "saturation": -31
                        },
                        {
                            "lightness": -33
                        },
                        {
                            "weight": 2
                        },
                        {
                            "gamma": 0.8
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "lightness": "-30"
                        },
                        {
                            "color": "#59769b"
                        },
                        {
                            "saturation": "-30"
                        },
                        {
                            "weight": "2.00"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 30
                        },
                        {
                            "saturation": 30
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "saturation": 20
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 20
                        },
                        {
                            "saturation": -20
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 10
                        },
                        {
                            "saturation": -30
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "saturation": 25
                        },
                        {
                            "lightness": 25
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "lightness": "52"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#607da1"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#cbdbf5"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": -20
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#abc8de"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "lightness": "69"
                        },
                        {
                            "color": "#2b394d"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ]
        });
        coordinate.map(item => {
            new google.maps.Marker({
                position: item,
                icon: { url: markerImage },
                map,
            });
            map.setCenter(new google.maps.LatLng(item.lat, item.lng));
            map.setZoom(10);
            map.panTo(item);
            this.addCircleRadius(item, map);
        });
    },
    addCircleRadius: function (location, map) {
        new google.maps.Circle({
            fillColor: '#67a3d9',
            fillOpacity: 0.4,
            strokeWeight: 0,
            map: map,
            center: location,
            radius: (location.radius * 1609),
            draggable: false,
        });
    },
}

const postcodeItem = (postcode, latitude, longitude, radius) => {
    let box = '<div class="box">'+radius + ' miles from ' + postcode+'</div>';
    let code = '<input type="hidden" class="input-code" name="code[]" value="'+postcode+'">';
    let radius_input = '<input type="hidden" class="input-radius" name="radius_marker[]" value="'+radius+'">';
    let lat = '<input type="hidden" class="input-lat" name="lat[]" value="'+latitude+'">';
    let lng = '<input type="hidden" class="input-lng" name="lng[]" value="'+longitude+'">';
    let button = '<div class="remove-post-code">' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M9.375 2.625L2.625 9.375" stroke="#FDFEFF" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<path d="M9.375 9.375L2.625 2.625" stroke="#FDFEFF" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg></div>';
    return '<div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 item-pc"><div class="input-post-code">'+box+code+radius_input+lat+lng+button+'</div></div>';
}

const isInArray = (lat, lng, arr) => {
    return (arr.some(e => e.lat === lat) && arr.some(e => e.lng === lng)) ? true : false;
}

const removeByKey = (array, params) => {
    array.some(function(item, index) {
        return (array[index][params.key] === params.value) ? !!(array.splice(index, 1)) : false;
    });
    return array;
}

var $uploadCrop,
$uploadPhoto,
rawImg;

function readFile(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $('.upload-demo').addClass('ready');
            $('#cropImagePop').modal('show');
            rawImg = e.target.result;
        }
        reader.readAsDataURL(input.files[0]);
    }
    else {
        swal("Sorry - you're browser doesn't support the FileReader API");
    }
}

var width = 404;
var height = 461;
if($('body').width() < 768){
    width = 313;
    height = 358;
}

$uploadCrop = $('#upload-demo').croppie({
    viewport: {
        width: width,
        height: height,
    },
    enableExif: true,
    enableResize: true,
});

$('#cropImagePop').on('shown.bs.modal', function(){
    $uploadCrop.croppie('bind', {
        url: rawImg
    }).then(function(){
        //console.log('jQuery bind complete');
    });
});

$('.company_logo_input').on('change', function () { 
    readFile(this); 
});

$('#cropImageBtn').on('click', function (ev) {
    $uploadCrop.croppie('result', {
        type: 'base64',
        format: 'jpeg',
        size: 'original',
    }).then(function (resp) {
        if(fileSizeValidation(resp)){
            $('#company-logo-output').attr('src', resp);
            $('#company_logo_croped').val(resp);
        }else{
            $('.company_logo_input').val('');
            $('#company-logo-output').attr('src', uploadErrorImage);
            $('.preview-company-logo').addClass('upload-error');
            $('.preview-company-logo').after('<div class="upload-error-text">The image size is too big. Please upload a new image</div>');
        }
        $('.upload-company-link').addClass('d-none');
        $('.preview-company-logo').removeClass('d-none');
        $('#cropImagePop').modal('hide');
    });
});

$('#cancelCropBtn').on('click', function (ev) {
    $('.company_logo_input').val('');
    $('#company-logo-output').attr('src', "");
    $('.preview-company-logo').addClass('d-none');
    $('#company_logo_croped').val("");
});

// Upload and crop galery images
$('#step_2marketing_photos').on('change', function () { 
    readMarketingPhoto(this); 
});

$uploadPhoto = $('#upload-photo-demo').croppie({
    viewport: {
        width: width,
        height: height,
    },
    enableExif: true,
    enableResize: true,
});

$('#cropMarketingPhotoPop').on('shown.bs.modal', function(){
    $uploadPhoto.croppie('bind', {
        url: rawImg
    }).then(function(){
        //console.log('jQuery bind complete');
    });
});

function readMarketingPhoto(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $('.upload-photo-demo').addClass('ready');
            $('#cropMarketingPhotoPop').modal('show');
            rawImg = e.target.result;
        }
        reader.readAsDataURL(input.files[0]);
    }
    else {
        swal("Sorry - you're browser doesn't support the FileReader API");
    }
}

$('#cropMarketingPhotoBtn').on('click', function (ev) {
    $uploadPhoto.croppie('result', {
        type: 'base64',
        format: 'jpeg',
        size: 'original',
    }).then(function (resp) {
        if(fileSizeValidation(resp)){
            $('.marketing_photos').append(photoGalleryItem(resp, false));
            $('.marketing_photos .upload-error').remove();
            $('.marketing_photos').closest('.form-group').find('.upload-error-text').remove();
        }else{
            $('.marketing_photos').append(photoGalleryItem(uploadErrorImage, true));
            $('.marketing_photos').after('<div class="upload-error-text">The image size is too big. Please upload a new image</div>');
        }
        $('.cropMarketingPhotoPopup').modal('hide');
        $('#step_2marketing_photos').val('');
    });
});

const photoGalleryItem = (img, error) => {
    let error_class = "";
    if(error){
        error_class = "upload-error";
    }
    let content =
	`<div class="upload-preview ${error_class}">
		<img src="${img}" class="company-logo-output"/>
		<input type="hidden" class="gallery-img-input" name="gallery_img[]" value="${img}">
		<div class="remove-image remove-gallery-img"></div>
	</div>`;
	return content;
}

$(document).on('click', '.remove-gallery-img', function () {
    $(this).parent('.upload-preview').remove();
    $('.marketing_photos').closest('.form-group').find('.upload-error-text').remove();
});

function fileSizeValidation(resp){
    let base64Length = resp.length - (resp.indexOf(',') + 1);
    let padding = (resp.charAt(resp.length - 2) === '=') ? 2 : ((resp.charAt(resp.length - 1) === '=') ? 1 : 0);
    let fileSize = base64Length * 0.75 - padding;
    if(fileSize > 10485760){
        return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./scripts/stepper/stepper-functions.js